export type Area = 'webshop' | 'prodega-easy';
export const TgArea = 'webshop';
export const PgArea = 'prodega-easy';
